import {
    IsNotEmpty,
    Length,
    IsOptional,
    IsEmail,
    IsArray,
    ArrayMaxSize,
    IsFQDN,
    IsObject,
    ValidateNested,
    IsNumber,
    IsPositive,
} from 'class-validator';
import {
    IPhoneNumber,
    ProspectCsvMatchMethod,
    ProspectDataEducationDto,
    ProspectDataExperienceDto,
    ProspectOwnerDto,
} from './prospect.dto';
import { IsLinkedinCompanyUrl } from '../validation/isLinkedinCompanyUrl';
import { IsLinkedinProfileUrl } from '../validation/isLinkedinProfileUrl';
import { IsSafeString } from '../validation/isSafeString';
import { Source } from '../source.enum';

export class CreateProspectDataDto {
    //Personal level
    @IsNotEmpty({ message: 'First Name field cannot be empty' })
    @IsSafeString({ message: 'Badly formated text' })
    @Length(1, 100, { message: 'Text must be between 1-100 characters' })
    firstName: string;

    @IsNotEmpty({ message: 'Last name field cannot be empty' })
    @IsSafeString({ message: 'Badly formated text' })
    @Length(1, 100, { message: 'Text must be between 1-100 characters' })
    lastName: string;

    @IsNotEmpty({ message: 'Full Name field cannot be empty' })
    @IsSafeString({ message: 'Badly formated text' })
    @Length(1, 200, { message: 'Text must be between 1-200 characters' })
    fullName: string;

    @IsOptional()
    @IsSafeString({ message: 'Badly formated text' })
    @Length(1, 100, { message: 'Text must be between 1-100 characters' })
    gender?: string;

    @IsOptional()
    @IsSafeString({ message: 'Badly formated text' })
    @Length(1, 100, { message: 'Text must be between 1-100 characters' })
    location?: string;

    @IsOptional()
    @IsSafeString({ message: 'Badly formated text' })
    @Length(1, 100, { message: 'Text must be between 1-100 characters' })
    locationCountry?: string;

    @IsOptional()
    @IsSafeString({ message: 'Badly formated text' })
    @Length(1, 100, { message: 'Text must be between 1-100 characters' })
    locationRegion?: string;

    @IsOptional()
    @IsSafeString({ message: 'Badly formated text' })
    @Length(1, 100, { message: 'Text must be between 1-100 characters' })
    locationCity?: string;

    @IsOptional()
    @IsSafeString({ message: 'Badly formated text' })
    @Length(1, 100, { message: 'Text must be between 1-100 characters' })
    @IsEmail(undefined, { message: 'Email is badly formated' })
    email?: string;

    @IsOptional()
    @IsSafeString({ message: 'Badly formated text' })
    @Length(1, 100, { message: 'Text must be between 1-100 characters' })
    emailVerificationStatus?: string;

    @IsOptional()
    @IsSafeString({ message: 'Badly formated text' })
    @Length(1, 100, { message: 'Text must be between 1-100 characters' })
    emailSource?: string;

    @IsOptional()
    @IsArray()
    @ArrayMaxSize(100, { message: 'Array cannot be longer than 100' })
    phoneNumbers?: IPhoneNumber[];

    @IsOptional()
    @IsSafeString({ message: 'Badly formated text' })
    @Length(1, 100, { message: 'Text must be between 1-100 characters' })
    birthYear?: string;

    @IsOptional()
    @IsSafeString({ message: 'Badly formated text' })
    @Length(1, 100, { message: 'Text must be between 1-100 characters' })
    birthDate?: string;

    @IsOptional()
    @IsArray()
    @ArrayMaxSize(100, { message: 'Array cannot be longer than 100' })
    interests?: string[];

    @IsOptional()
    @IsArray()
    @ArrayMaxSize(100, { message: 'Array cannot be longer than 100' })
    skills?: string[];

    @IsOptional()
    @IsNumber()
    yearsOfExperience?: number;

    // Social Media
    @IsOptional()
    @IsSafeString({ message: 'Badly formated text' })
    @Length(1, 100, { message: 'Text must be between 1-100 characters' })
    facebookProfileUrl?: string;

    @IsOptional()
    @IsSafeString({ message: 'Badly formated text' })
    @Length(1, 100, { message: 'Text must be between 1-100 characters' })
    twitterProfileUrl?: string;

    @IsOptional()
    @IsSafeString({ message: 'Badly formated text' })
    @Length(1, 100, { message: 'Text must be between 1-100 characters' })
    githubProfileUrl?: string;

    @IsOptional()
    @IsSafeString({ message: 'Badly formated text' })
    @Length(1, 100, { message: 'Text must be between 1-100 characters' })
    @IsLinkedinProfileUrl({ message: 'LinkedinUrl is badly formatted' })
    linkedinProfileUrl?: string;

    @IsOptional()
    @IsSafeString({ message: 'Badly formated text' })
    @Length(1, 100, { message: 'Text must be between 1-100 characters' })
    linkedinUserId?: string;

    @IsOptional()
    @IsSafeString({ message: 'Badly formated text' })
    @Length(1, 500, { message: 'Text must be between 1-500 characters' })
    linkedinProfileImgUrl?: string;

    @IsOptional()
    @IsNumber()
    @IsPositive()
    linkedinNumberOfConnections?: number;

    @IsOptional()
    @IsSafeString({ message: 'Badly formated text' })
    @Length(1, 100, { message: 'Text must be between 1-100 characters' })
    linkedinHeadline?: string;

    @IsOptional()
    @IsSafeString({ message: 'Badly formated text' })
    @Length(1, 100, { message: 'Text must be between 1-100 characters' })
    linkedinDescription?: string;

    //Occupation level
    @IsOptional()
    education?: ProspectDataEducationDto[];

    @IsOptional()
    experiences?: ProspectDataExperienceDto[];

    @IsOptional()
    @IsSafeString({ message: 'Badly formated text' })
    @Length(1, 100, { message: 'Text must be between 1-100 characters' })
    industry?: string;

    @IsOptional()
    @IsSafeString({ message: 'Badly formated text' })
    @Length(1, 100, { message: 'Text must be between 1-100 characters' })
    occupationTitle?: string;

    @IsOptional()
    @IsSafeString({ message: 'Badly formated text' })
    @Length(1, 100, { message: 'Text must be between 1-100 characters' })
    occupationRole?: string;

    @IsOptional()
    @IsSafeString({ message: 'Badly formated text' })
    @Length(1, 100, { message: 'Text must be between 1-100 characters' })
    occupationSubRole?: string;

    @IsOptional()
    @IsSafeString({ message: 'Badly formated text' })
    @IsArray()
    @ArrayMaxSize(100, { message: 'Array cannot be longer than 100' })
    occupationLevels?: string[];

    @IsOptional()
    @IsSafeString({ message: 'Badly formated text' })
    @Length(1, 100, { message: 'Text must be between 1-100 characters' })
    occupationDuration?: string;

    @IsOptional()
    @IsSafeString({ message: 'Badly formated text' })
    @Length(1, 100, { message: 'Text must be between 1-100 characters' })
    occupationStartDate?: string;

    //Organization level

    @IsSafeString({ message: 'Badly formated text' })
    @Length(1, 100, { message: 'Text must be between 1-100 characters' })
    organizationName: string;

    @IsOptional()
    @IsSafeString({ message: 'Badly formated text' })
    @Length(1, 100, { message: 'Text must be between 1-100 characters' })
    organizationId?: string;

    @IsOptional()
    @IsSafeString({ message: 'Badly formated text' })
    @Length(1, 100, { message: 'Text must be between 1-100 characters' })
    organizationIndustry?: string;

    @IsOptional()
    @IsSafeString({ message: 'Badly formated text' })
    @Length(1, 100, { message: 'Text must be between 1-100 characters' })
    organizationSize?: string;

    @IsFQDN(undefined, { message: 'Must be a valid domain' })
    organizationDomain?: string;

    @IsOptional()
    @IsSafeString({ message: 'Badly formated text' })
    @Length(1, 100, { message: 'Text must be between 1-100 characters' })
    @IsLinkedinCompanyUrl({ message: 'Linkedin Url is badly formatted' })
    organizationLinkedinUrl?: string;

    @IsOptional()
    @IsSafeString({ message: 'Badly formated text' })
    @Length(1, 100, { message: 'Text must be between 1-100 characters' })
    personId?: string;

    @IsOptional()
    @IsSafeString({ message: 'Badly formated text' })
    @Length(1, 200, { message: 'Text must be between 1-200 characters' })
    pdlDatasetVersion?: string;

    @IsOptional()
    @IsSafeString({ message: 'Badly formated text' })
    @Length(1, 200, { message: 'Text must be between 1-200 characters' })
    microsoftDynamicsId?: string;

    @IsOptional()
    @IsSafeString({ message: 'Badly formated text' })
    @Length(1, 200, { message: 'Text must be between 1-200 characters' })
    csvMatchingMethod?: ProspectCsvMatchMethod;

    originalData?: Omit<CreateProspectDataDto, 'originalData'>;

    constructor(iCreateProspectData: CreateProspectDataDto) {
        this.firstName = iCreateProspectData.firstName?.toLowerCase()?.trim();
        this.lastName = iCreateProspectData.lastName?.toLowerCase()?.trim();
        this.fullName = iCreateProspectData.fullName?.toLowerCase()?.trim();
        this.gender = iCreateProspectData.gender?.toLowerCase()?.trim();
        this.location = iCreateProspectData.location?.toLowerCase()?.trim();
        this.email = iCreateProspectData.email?.toLowerCase()?.trim();
        this.emailVerificationStatus = iCreateProspectData.emailVerificationStatus?.toLowerCase()?.trim();
        this.emailSource = iCreateProspectData.emailSource?.toLowerCase()?.trim();
        this.phoneNumbers = iCreateProspectData.phoneNumbers;
        this.birthYear = iCreateProspectData.birthYear?.toLowerCase()?.trim();
        this.birthDate = iCreateProspectData.birthDate?.toLowerCase()?.trim();
        this.interests = iCreateProspectData.interests;
        this.skills = iCreateProspectData.skills;
        this.yearsOfExperience = iCreateProspectData.yearsOfExperience;
        this.facebookProfileUrl = iCreateProspectData.facebookProfileUrl?.toLowerCase()?.trim();
        this.twitterProfileUrl = iCreateProspectData.twitterProfileUrl?.toLowerCase()?.trim();
        this.githubProfileUrl = iCreateProspectData.githubProfileUrl?.toLowerCase()?.trim();
        this.linkedinProfileUrl = iCreateProspectData.linkedinProfileUrl?.trim(); // DO NOT LOWERCASE
        this.linkedinUserId = iCreateProspectData.linkedinUserId?.trim(); // DO NOT LOWERCASE
        this.linkedinProfileImgUrl = iCreateProspectData.linkedinProfileImgUrl?.trim(); // DO NOT LOWERCASE
        this.linkedinNumberOfConnections = iCreateProspectData.linkedinNumberOfConnections;
        this.linkedinHeadline = iCreateProspectData.linkedinHeadline?.toLowerCase()?.trim();
        this.linkedinDescription = iCreateProspectData.linkedinDescription?.toLowerCase()?.trim();
        this.education = iCreateProspectData.education;
        this.experiences = iCreateProspectData.experiences;
        this.industry = iCreateProspectData.industry?.toLowerCase()?.trim();
        this.occupationTitle = iCreateProspectData.occupationTitle?.toLowerCase()?.trim();
        this.occupationRole = iCreateProspectData.occupationRole?.toLowerCase()?.trim();
        this.occupationSubRole = iCreateProspectData.occupationSubRole?.toLowerCase()?.trim();
        this.occupationLevels = iCreateProspectData.occupationLevels;
        this.occupationDuration = iCreateProspectData.occupationDuration?.toLowerCase()?.trim();
        this.occupationStartDate = iCreateProspectData.occupationStartDate?.toLowerCase()?.trim();
        this.organizationId = iCreateProspectData.organizationId?.toLowerCase()?.trim();
        this.organizationIndustry = iCreateProspectData.organizationIndustry?.toLowerCase()?.trim();
        this.organizationName = iCreateProspectData.organizationName?.toLowerCase()?.trim();
        this.organizationSize = iCreateProspectData.organizationSize?.toLowerCase()?.trim();
        this.organizationDomain = iCreateProspectData.organizationDomain?.trim(); // DO NOT LOWERCASE
        this.organizationLinkedinUrl = iCreateProspectData.organizationLinkedinUrl?.toLowerCase()?.trim();
        this.personId = iCreateProspectData.personId; // DO NOT LOWERCASE
        this.pdlDatasetVersion = iCreateProspectData.pdlDatasetVersion;
        this.microsoftDynamicsId = iCreateProspectData.microsoftDynamicsId; // DO NOT LOWERCASE
        this.csvMatchingMethod = iCreateProspectData.csvMatchingMethod; // DO NOT LOWERCASE
        this.originalData = iCreateProspectData.originalData; // DO NOT LOWERCASE
    }

    static fromDocument(iCreateProspectData: CreateProspectDataDto) {
        const createProspectDataDto = new CreateProspectDataDto(iCreateProspectData);
        return createProspectDataDto;
    }
}

export class CreateProspectDto {
    @IsNotEmpty()
    @IsSafeString()
    userOrganizationId: string;

    @IsNotEmpty()
    @IsSafeString()
    createdByUserId: string;

    @IsSafeString({ message: 'Badly formated text' })
    @IsOptional()
    personId?: string;

    @IsObject()
    @ValidateNested()
    data: CreateProspectDataDto;

    @IsOptional()
    source: Source;

    @IsOptional()
    owner?: ProspectOwnerDto;

    constructor(iCreateProspect: CreateProspectDto) {
        this.userOrganizationId = iCreateProspect.userOrganizationId;
        this.createdByUserId = iCreateProspect.createdByUserId;
        this.personId = iCreateProspect.personId;
        this.data = CreateProspectDataDto.fromDocument(iCreateProspect.data);
        this.source = iCreateProspect.source;
        this.owner = iCreateProspect.owner;
    }

    static fromDocument(iCreateProspect: CreateProspectDto) {
        const createProspectDto = new CreateProspectDto(iCreateProspect);
        return createProspectDto;
    }
}
